export class FavouriteModel {
  id: number = 0;
  userId: number = 0;
  clinicId: number = 0;
  doctorId: number = 0;

  constructor(init?: Partial<FavouriteModel>) {
    if (init) Object.assign(this, init);
  }
}
